import { LoaderCircle } from "lucide-react";
import { Button } from "./ui/button";

export function ButtonSubmit({ loading = false, children, variant }) {
  return (
    <Button type="submit" variant={variant} size="lg" className="w-full cursor-pointer" disabled={loading} >
      {loading && <LoaderCircle className="animate-spin text-slate-50 size-5" />}
      {children}
    </Button>
  )
}